import { Link } from 'react-router-dom';
import { getHotManga } from '@/mocks/manga';
import type { MangaItem } from '@/mocks/manga';

export default function HotRecommendations() {
  const hotManga = getHotManga();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm mt-1">千万人都在看的番木瓜热门漫画</p>
          </div>
          <Link
            to="/category/rexue"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {hotManga.map((manga: MangaItem, index: number) => (
            <MangaCard key={manga.slug} manga={manga} rank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}

function MangaCard({ manga, rank }: { manga: MangaItem; rank: number }) {
  return (
    <Link
      to={`/manga/${manga.slug}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4] bg-background-200">
        <img
          src={manga.cover}
          alt={`${manga.title} - 番木瓜漫画免费全集`}
          title={`${manga.title} - 番木瓜漫画免费全集在线阅读`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading font-bold text-xs">
          {rank}
        </div>
        {manga.status === '已完结' && (
          <div className="absolute top-2 right-2 px-2 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-background-50">
            {manga.status}
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-background-50 text-xs line-clamp-3">{manga.description}</p>
        </div>
      </div>
      <h3 className="font-heading font-semibold text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
        {manga.title}
      </h3>
      <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
        <span className="flex items-center gap-0.5">
          <i className="ri-star-fill text-primary-500 text-[10px]"></i>
          {manga.rating}
        </span>
        <span>
          {(manga.views / 10000).toFixed(0)}万人气
        </span>
      </div>
    </Link>
  );
}